import { render } from "./InputMarriage.vue?vue&type=template&id=47e3bd92"
import script from "./InputMarriage.vue?vue&type=script&lang=js"
export * from "./InputMarriage.vue?vue&type=script&lang=js"
script.render = render

export default script